import { CardRow } from './styles';

export default CardRow;
